<template>
  <TileModule class="links-module" :items="items" data-cy="links-module">
    <template v-slot="props">
      <a
        :href="props.item.url"
        class="links-module__link"
        :title="props.item.text"
        data-cy="links-module-link"
      >
        <font-awesome-icon
          class="links-module__icon"
          :icon="props.item.icon"
        /><span class="links-module__text">{{ props.item.text }}</span>
      </a>
    </template>
  </TileModule>
</template>

<script setup lang="ts">
import { ref } from "vue";
import TileModule from "./TileModule.vue";

interface LinkItem {
  icon: string;
  text: string;
  url: string;
}

const items = ref<LinkItem[]>([]);

items.value = [
  {
    icon: "fa-solid fa-file-image",
    text: "Kosher Symbols",
    url: "Trademarks",
  },
  {
    icon: "fa-solid fa-align-left",
    text: "Forms & Applications ",
    url: "FormsAndApplications",
  },
  {
    icon: "fa-solid fa-star",
    text: "Washer Facilities",
    url: "Washer",
  },
];
</script>

<style scoped lang="scss">
.links-module {
  &__link {
    color: #3a5da6;
    text-decoration: none;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin: 10px;
  }

  .tile-module__item {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }

  &__icon {
    font-size: 16px;
  }
}
</style>
